/**
 * URL base del servidor Socket.io (sin /api).
 */
function getSocketUrl() {
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL.replace(/\/$/, "");
  }

  const api = process.env.REACT_APP_API_URL || "http://localhost:4000/api";
  return api.replace(/\/api\/?$/, "");
}

export default getSocketUrl;
